//react
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';
import { useEffect } from 'react';

const A8netTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'a8net';
    const isExistScript = document.getElementById(scriptId);
    if (!!isExistScript) isExistScript.remove();
    const scriptId1 = 'a8net-load1';
    const isExistLoadScript1 = document.getElementById(scriptId1);
    if (!!isExistLoadScript1) isExistLoadScript1.remove();

    if (isThanks) {
      const { order_code: orderCode = '', billing_amount = 0, tax_amount = 0 } = order || {};
      const script = document.createElement('script');
      const price = billing_amount + tax_amount;
      script.id = scriptId;
      script.innerHTML = `
        a8sales({
          "pid": "s00000016921001",
          "order_number": "${orderCode}",
          "currency": "JPY",
          "items": [
          {
          "code": "a8",
          "price": ${price},
          "quantity": 1,
          },
          ],
          "total_price": ${price}
          });
      `;
      document.body.appendChild(script);
    } else {
      const script1 = document.createElement('script');
      script1.src = '//statics.a8.net/a8sales/a8sales.js';
      script1.id = scriptId1;
      document.head.appendChild(script1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isThanks]);
  return isThanks ? <span id="a8sales"></span> : <></>;
};

export default A8netTag;
